import { BankTransferPaymentConfig } from '@/models/common/bank-transfer-payment-config';
import { PaymentBasics } from '@/models/common/payment-basics';
import { PaymentOnHandingOver } from '@/models/common/payment-on-handing-over';
import { PayPalPaymentConfig } from '@/models/common/paypal-payment-config';
import { PersonalBizumPaymentConfig } from '@/models/common/personal-bizum-payment-config';
import { RedsysPaymentConfig } from '@/models/common/redsys-payment-config';
import { UserEntityPermissionsType } from '@/models/users/user-permissions/user-entity-permissions';

export class BusinessPaymentOptions {
    public id: number = 0;
    public businessId: number = 0;
    public paymentBasics: PaymentBasics = new PaymentBasics();
    public paymentOnHandingOver: PaymentOnHandingOver = new PaymentOnHandingOver();
    public bankTransferConfig: BankTransferPaymentConfig = new BankTransferPaymentConfig();
    public payPalConfig: PayPalPaymentConfig = new PayPalPaymentConfig();
    public redsysConfig: RedsysPaymentConfig = new RedsysPaymentConfig();
    public personalBizumConfig: PersonalBizumPaymentConfig = new PersonalBizumPaymentConfig();

    public get permissionsGroupType(): UserEntityPermissionsType {
        return UserEntityPermissionsType.Businesses;
    }

    public get permissionsIdToCheck(): number {
        return this.businessId;
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(
            this,
            json,
            { paymentBasics: json.paymentBasics ? new PaymentBasics(json.paymentBasics) : new PaymentBasics() },
            { paymentOnHandingOver: json.paymentOnHandingOver ? new PaymentOnHandingOver(json.paymentOnHandingOver) : new PaymentOnHandingOver() },
            { bankTransferConfig: json.bankTransferConfig ? new BankTransferPaymentConfig(json.bankTransferConfig) : new BankTransferPaymentConfig() },
            { payPalConfig: json.payPalConfig ? new PayPalPaymentConfig(json.payPalConfig) : new PayPalPaymentConfig() },
            { redsysConfig: json.redsysConfig ? new RedsysPaymentConfig(json.redsysConfig) : new RedsysPaymentConfig() },
            { personalBizumConfig: json.personalBizumConfig ? new PersonalBizumPaymentConfig(json.personalBizumConfig) : new PersonalBizumPaymentConfig() },
        );
    }

    public clone(): BusinessPaymentOptions {
        const businessPaymentOptions: BusinessPaymentOptions = new BusinessPaymentOptions();

        businessPaymentOptions.id = this.id;
        businessPaymentOptions.businessId = this.businessId;
        businessPaymentOptions.paymentBasics = this.paymentBasics.clone();
        businessPaymentOptions.paymentOnHandingOver = this.paymentOnHandingOver.clone();
        businessPaymentOptions.bankTransferConfig = this.bankTransferConfig.clone();
        businessPaymentOptions.payPalConfig = this.payPalConfig.clone();
        businessPaymentOptions.redsysConfig = this.redsysConfig.clone();
        businessPaymentOptions.personalBizumConfig = this.personalBizumConfig.clone();

        return businessPaymentOptions;
    }
}
